'use strict';

module.exports = {};

if ('production' != process.env.NODE_ENV) {
  Object.freeze(module.exports);
}



//////////////////
// WEBPACK FOOTER
// ./~/empty/object.js
// module id = ./node_modules/empty/object.js
// module chunks = 0